import { Link } from "react-router-dom";
import companyLogo from "../../assets/img/censynLogo.svg";

function Navbar() {
  return (
    <header className="tw-absolute tw-top-0 tw-left-0  tw-w-full tw-z-50 tw-bg-transparent">
      <div className="tw-max-w-full tw-mx-auto tw-px-4 md:tw-px-16">
        <nav className="tw-flex tw-items-center tw-justify-between tw-py-4">
          <Link to="/" className="tw-flex tw-items-center">
            <img
              src={companyLogo}
              alt="CenSyn Logo"
              className="tw-h-10 md:tw-h-12"
            />
          </Link>

          <div className="tw-flex tw-items-center tw-space-x-2 md:tw-space-x-4">
            {/* <Link
              to="/technology"
              className="tw-no-underline tw-bg-white tw-text-black tw-px-3 tw-py-1 tw-rounded-full tw-text-xs md:tw-px-5 md:tw-py-2 md:tw-text-sm hover:tw-text-black hover:tw-bg-gray-100 tw-transition"
            >
              Technology
            </Link> */}
            <Link
              to="/login"
              className="tw-no-underline tw-bg-[#08acac] tw-text-white tw-px-3 tw-py-1 tw-rounded-full tw-text-xs md:tw-px-5 md:tw-py-2 md:tw-text-sm hover:tw-text-white hover:tw-bg-[#069494] tw-shadow-sm tw-transition"
            >
              Sign In
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
